import axios from 'axios'

let controller // Declare AbortController outside to keep track of it

const fetchData = async (
  endpoint,
  method = 'GET',
  data = null,
  headers = {},
  cancelToken = false // Cancel token flag to determine if cancellation is needed
) => {
  const url = `${endpoint}`

  // If there's a previous request, cancel it using AbortController, but only if cancelToken is true
  if (cancelToken && controller) {
    controller.abort() // Abort the previous request
  }

  let signal // Declare signal variable to store the signal from AbortController

  // Create a new AbortController instance for each request only if cancelToken is true
  if (cancelToken) {
    controller = new AbortController()
    signal = controller.signal
  }

  try {
    const response = await axios({
      url,
      method,
      data,
      headers,
      ...(cancelToken && { signal }), // Add signal to request only if cancelToken is true
    })

    return response.data
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Request canceled:', error.message) // Handle cancellation
    } else if (error.response) {
      console.error('Request failed with status:', error.response.status)
      console.error('Response data:', error.response.data)
    } else if (error.request) {
      console.error('No response received:', error.request)
    } else {
      console.error('Request setup error:', error.message)
    }

    throw error
  }
}

export default fetchData
